<template lang="pug">
.v-search-result.search-result(v-if="data" :id="data?.id")
	.search-result__title(v-if="data.title") {{ data.title }}
	.search-result__field(v-if="data.field")
		v-field-search(:field="data.field" :model-value="data.field.value")
	.search-result__count(v-if="data.itemsCount && data.items?.length") {{ data.itemsCount }}
	template(v-if="data.items && data.items.length")
		.search-result__items
			.search-result__item(v-for="item in data.items")
				a.search-result__item-title(v-if="item.title" :href="item.link")
					span.search-result__item-title-text {{ item.title }}
					v-svg-icon.search-result__item-icon(icon="arrow-right")
				.search-result__item-text(v-if="item.text" v-html="item.text")
				.search-result__item-links(v-if="item.items")
					a.search-result__item-link(v-for="link in item.items" :href="link.link") {{ link.text }}
		v-page-nav.search-result__page-nav(:page="data.page" @navigate="navigate")
	.search-result__message(v-else-if="data.notFound") {{data.notFound}}
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			page: null
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.data = data;
			this.page = data.page;
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id,
					page: dataSetOptions.page || this.page
				},
			}, dataSetOptions);
		},

		navigate(page) {
			this.page.offset = page.offset;
			this.page.limit = page.limit;
			this.requestDataLoad({updateUrl: true});
		},
	}
}

</script>